<script>
  import { _ } from 'svelte-i18n'
  import { modals, server_path, flash_content, user_saved_selections, user_valid, user_saved_selections_loading_state } from '../../stores'
  import { createEventDispatcher } from 'svelte';
  import { reloadSelections } from '../../services/selections'
  import axios from 'axios'
  import Modal from '../../elements/Modal.svelte'
  import SavedSelectionList from '../SavedSelectionList.svelte';
  import Button from '../../elements/Button.svelte';
  import Toggle from '../../elements/Toggle.svelte';
  import Tabs from '../../elements/Tabs.svelte';
  import Blink from '../../elements/Blink.svelte';

  export let has_selected_fonts = false
  
  let is_editing = false
  let show_error = false
  
  $: has_saved_selections_data = !!$user_saved_selections && $user_saved_selections.filter(s => s.autosave == 0).length !== 0
  $: has_selection_history_date = !!$user_saved_selections && $user_saved_selections.filter(s => s.autosave == 1).length !== 0
  
  const modal_id = 'loadSelection'
  const dispatch = createEventDispatcher()

  const handleLoad = (event) => {
    dispatch("loadSelection", event.detail)
    modals.close()
  }

  const tab_options = [
    {value:false, display:'Saved selections'}, 
    {value:true, display:'Selection history'}
  ]
  let is_showing_history = false
  
  async function handleDelete(event) {
    let selection_id = event.detail
    console.log('User - deleting saved selection: selection_id')
    if (!selection_id) { console.warn('No selection id exists, cannot delete selection'); return }

    show_error = false

    let form_data = new FormData()
    form_data.append('selection_id', selection_id)
    axios.post($server_path + 'selections/delete.php', form_data, {withCredentials: true})
    .then((response) => {
      if (response.data === false) show_error = true
      else {
        reloadSelections()
        $flash_content = $_('flashes.userDeletedSelection')
      }
    }, (error) => {
      console.log("Error with delete selection request")
      // bugsnag here
    })
  }
  
  const resetModalVars = () => {
    is_editing = false
    is_showing_history = false
  }

  const handleReloadSelections = () => {
    user_saved_selections_loading_state.setLoading()
    // wait 1 second
    setTimeout(() => {
      reloadSelections()
    }, 1000)
  }
</script>

<Modal large id={modal_id} on:modalClosed={resetModalVars} flush_header>
  <span slot="header">
    {#if is_showing_history}
      {@html $_('modals.loadSelection.titleHistory')}
      {#if has_selection_history_date}
        <span class="toggle_wrapper" class:is_editing>
          <!-- svelte-ignore a11y-invalid-attribute -->
          <a class:active={is_editing} href="#" on:click={() => is_editing = !is_editing}>{@html is_editing ? '&ensp;' + $_('modals.loadSelection.editing') : '&ensp;' + $_('modals.loadSelection.edit')}</a>
          <Toggle bind:checked={is_editing}/>
        </span>
      {/if}
    {:else}
      {@html $_('modals.loadSelection.title')}
      {#if has_saved_selections_data}
        <span class="toggle_wrapper" class:is_editing>
          <!-- svelte-ignore a11y-invalid-attribute -->
          <a class:active={is_editing} href="#" on:click={() => is_editing = !is_editing}>{@html is_editing ? '&ensp;' + $_('modals.loadSelection.editing') : '&ensp;' + $_('modals.loadSelection.edit')}</a>
          <Toggle bind:checked={is_editing}/>
        </span>
      {/if}
    {/if}
  </span>

  <span slot="content">
    <Tabs tab_options={tab_options} flush={true} bind:selected_tab={is_showing_history} />
    
    {#if is_showing_history}
      {#if has_selection_history_date}
        <p class="info">
          {#if is_editing}
            {@html $_('modals.loadSelection.chooseToDelete')}
          {:else}
            {@html $_('modals.loadSelection.chooseToLoad')}
            {#if has_selected_fonts}
              <small>{@html $_('modals.loadSelection.selectedFontsNotice')}</small>
            {/if}
          {/if}
        </p>
        <SavedSelectionList {is_editing} {is_showing_history} on:selectionSelect={handleLoad} on:selectionDelete={handleDelete}/>
      {:else}
        {#if $user_saved_selections_loading_state.loading}
          <div class="state_info loading">
            <Blink><h3>Loading saved selections...</h3></Blink>
          </div>
        {:else if $user_saved_selections_loading_state.error}
          <div class="state_info error_loading">
            <h3>Error loading saved selections</h3>
            <p>There was an error loading your saved selections ({$user_saved_selections_loading_state.error}).</p>
          </div>
        {:else}
          <div class="state_info">
            <h3>{$_('modals.loadSelection.emptyTitleHistory')}</h3>
            {#if $user_valid}
              {@html $_('modals.loadSelection.emptyStateHistory')}
            {:else}
              {@html $_('modals.loadSelection.emptyStateHistoryPro')}
            {/if}
          </div>
        {/if}
      {/if}
    {:else}
      {#if has_saved_selections_data}
        <p class="info">
          {#if is_editing}
            {@html $_('modals.loadSelection.chooseToDelete')}
          {:else}
            {@html $_('modals.loadSelection.chooseToLoad')}
            {#if has_selected_fonts}
              <small>{@html $_('modals.loadSelection.selectedFontsNotice')}</small>
            {/if}
          {/if}
        </p>
        <SavedSelectionList {is_editing} {is_showing_history} on:selectionSelect={handleLoad} on:selectionDelete={handleDelete}/>
      {:else}
        {#if $user_saved_selections_loading_state.loading}
          <div class="state_info loading">
            <Blink><h3>Loading saved selections...</h3></Blink>
          </div>
        {:else if $user_saved_selections_loading_state.error}
          <div class="state_info error_loading">
            <h3>Error loading saved selections</h3>
            <p>There was an error loading your saved selections ({$user_saved_selections_loading_state.error}).</p>
          </div>
        {:else}
          <div class="state_info">
            <h3>{$_('modals.loadSelection.emptyTitle')}</h3>
            {#if $user_valid}
              {@html $_('modals.loadSelection.emptyState')}
            {:else}
              {@html $_('modals.loadSelection.emptyStatePro')}
            {/if}
          </div>
        {/if}
      {/if}
    {/if}
  </span>
  
  <span slot="footer" class="footer">
    {#if $user_saved_selections_loading_state.error}
      <Button kind="accent" on:click={handleReloadSelections}>Retry loading</Button>
    {/if}
    <Button kind="outline" on:click={() => {modals.close(); resetModalVars()}}>{$_('buttons.close')}</Button>
  </span>

</Modal>

<style>
  .info {
    margin-bottom: 2rem;
  }
  .info small{
    display: block;
    margin-top: 1rem;
  }
  .toggle_wrapper {
    position: absolute;
    top: 3.3rem;
    right: 3rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 1.5rem 0.5rem 1rem;
    border-radius: 2rem;
    font-size: 1.5rem;
    font-family: 'PensumSans-Book';
    line-height: 3rem;
    color: var(--c-text);
    background-color: var(--c-bg);
    transition: all var(--transition-props);
  }
  :global(.dark_theme) .toggle_wrapper {
    background-color: var(--c-flash-bg);
  }
  .toggle_wrapper.is_editing {
    background-color: var(--c-flash-onboarding-bg);
    color: var(--c-text-on-fill);
  }
  .toggle_wrapper a {
    text-decoration: none;
    cursor: pointer;
  }
  .toggle_wrapper a.active {
    color: var(--c-text-on-fill);
  }
  .footer {
    display: flex;
    margin-top: 2rem;
    flex-direction: row;
    gap: 1.5rem;
    margin-top: 2rem;
  }
  .state_info {
    padding: 2rem 1.5rem;
    background-color: var(--c-bg);
    border-radius: 1rem;
    color: var(--c-text-faded);
  }
  .state_info h3 {
    margin-bottom: 1rem;
    color: var(--c-text);
  }
  .state_info.error_loading h3 {
    color: var(--c-danger);
  }
</style>

